import React, { useEffect, useState } from "react";
import { useL } from "@/lib/useL";
import { useParams } from "react-router-dom";
import { ChevronLeft, ChevronRight, Download } from "lucide-react";
import { FlipCard } from "@/components/FlipCard";
import { SwipeArea } from "@/components/CardNav";

const API = process.env.REACT_APP_BACKEND_URL;

// Public, read-only flashcards (shared by a teacher via link / QR code).
export default function PublicFlashcards() {
  const L = useL();
  const { id } = useParams();
  const [deck, setDeck] = useState(null);
  const [i, setI] = useState(0);
  const [flipped, setFlipped] = useState(false);
  useEffect(() => {
    fetch(`${API}/api/public/flashcards/${id}`).then((r) => (r.ok ? r.json() : false)).then(setDeck).catch(() => setDeck(false));
  }, [id]);
  if (deck === false) return <div className="p-10" data-testid="public-cards-not-found">{L("Ce jeu de cartes n'est pas (ou plus) partagé.", "This card deck is not (or no longer) shared.")}</div>;
  if (!deck) return null;
  const go = (d) => { setFlipped(false); setI((x) => Math.min(Math.max(x + d, 0), deck.cards.length - 1)); };
  const nav = "p-3 border border-[#002FA7] text-[#002FA7] disabled:opacity-30";
  return (
    <div className="max-w-3xl mx-auto px-6 py-10" data-testid="public-cards-page">
      <div className="font-mono uppercase tracking-[0.2em] text-[11px] text-[#002FA7] mb-2">SUX1 · {L("Cartes de révision", "Flashcards")}</div>
      <h1 className="text-3xl font-black mb-6" style={{ fontFamily: "Outfit" }}>{deck.title}</h1>
      <SwipeArea onPrev={() => go(-1)} onNext={() => go(1)}>
        <FlipCard q={deck.cards[i].q} a={deck.cards[i].a} flipped={flipped} onFlip={() => setFlipped((f) => !f)} testid="public-flip-card" />
      </SwipeArea>
      <div className="flex items-center justify-between mt-4">
        <button type="button" className={nav} onClick={() => go(-1)} disabled={i === 0} aria-label={L("Précédente", "Previous")} data-testid="public-cards-prev"><ChevronLeft className="w-5 h-5" /></button>
        <span className="font-mono text-sm" data-testid="public-cards-counter">{i + 1} / {deck.cards.length}</span>
        <button type="button" className={nav} onClick={() => go(1)} disabled={i === deck.cards.length - 1} aria-label="Suivante" data-testid="public-cards-next"><ChevronRight className="w-5 h-5" /></button>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3 mt-10 pt-6 border-t border-border text-sm">
        <a href={`${API}/api/public/flashcards/${id}/pdf`} className="flex items-center gap-2 text-[#002FA7] underline" data-testid="public-cards-pdf"><Download className="w-4 h-4" /> {L("Imprimer les cartes (PDF)", "Print the cards (PDF)")}</a>
        <a href="/" className="text-[#002FA7] underline" data-testid="public-cards-cta">{L("Créer mes propres cartes avec SUX1", "Create my own flashcards with SUX1")}</a>
      </div>
    </div>
  );
}
